import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const BO_GET_USER_CHALLENGES = createRequestTypes('BO_GET_USER_CHALLENGES');
export const boGetUserChallenges = {
  request: search => action(BO_GET_USER_CHALLENGES[REQUEST], { search }),
  success: data => action(BO_GET_USER_CHALLENGES[SUCCESS], { data }),
  failure: error => action(BO_GET_USER_CHALLENGES[FAILURE], { error }),
};

export const BO_GET_USER_CHALLENGE = createRequestTypes('BO_GET_USER_CHALLENGE');
export const boGetUserChallenge = {
  request: challengeId => action(BO_GET_USER_CHALLENGE[REQUEST], { challengeId }),
  success: data => action(BO_GET_USER_CHALLENGE[SUCCESS], { data }),
  failure: error => action(BO_GET_USER_CHALLENGE[FAILURE], { error }),
};

export const BO_INCREASE_USER_CHALLENGE = createRequestTypes('BO_INCREASE_USER_CHALLENGE');
export const boIncreaseUserChallenge = {
  request: challengeId => action(BO_INCREASE_USER_CHALLENGE[REQUEST], { challengeId }),
  success: () => action(BO_INCREASE_USER_CHALLENGE[SUCCESS]),
  failure: error => action(BO_INCREASE_USER_CHALLENGE[FAILURE], { error }),
};

export const BO_CLOSE_USER_CHALLENGE = createRequestTypes('BO_CLOSE_USER_CHALLENGE');
export const boCloseUserChallenge = {
  request: ({ challengeId, reason }) =>
    action(BO_CLOSE_USER_CHALLENGE[REQUEST], {
      challengeId,
      reason,
    }),
  success: () => action(BO_CLOSE_USER_CHALLENGE[SUCCESS]),
  failure: error => action(BO_CLOSE_USER_CHALLENGE[FAILURE], { error }),
};
